<template>
  <card class="flex flex-col gap-6" padding="py-8 px-10">
    <rpm-input
        id="current_password"
        type="password"
        label="Senha atual"
        placeholder="Senha atual"
        required
        v-model="form.current_password"
        :errors="errors.current_password"
    ></rpm-input>

    <div class="flex flex-row gap-4">
      <rpm-input
          class="w-full"
          id="password"
          type="password"
          placeholder="Nova senha"
          label="Nova senha"
          required
          v-model="form.password"
          :errors="errors.password"
      ></rpm-input>

      <rpm-input
          class="w-full"
          id="password"
          type="password"
          placeholder="Repita a nova senha"
          label="Repita a nova senha"
          required
          v-model="form.password_confirmation"
          :errors="errors.password"
      ></rpm-input>
    </div>
    {{ user }}

    <div class="flex flex-row justify-center mt-4">
      <rpm-button
          label="Alterar senha"
          @click="changePassword"
      ></rpm-button>
    </div>
  </card>
</template>

<script>

import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed, ref, onMounted} from "vue";

export default {
  name: "ChangePassword",
  mounted() {
    this.form.id = this.$user.id
  },
  data() {
    return {
      form: {
        current_password: '',
        password: '',
        password_confirmation: ''
      },
      errors: {}
    }
  },
  methods: {
    changePassword() {
      this.$store.dispatch("changePasswordAfterRegistration", this.form).then(() => {
        this.$notify('Senha alterada com sucesso', 'success');
        this.$router.push({path: "/"});
      }).catch((response) => {
        this.errors = response.response.data.errors;
      });
    }
  },

};
</script>

<style></style>
